/**
 * Task panel (slide-out) — renders the same Task Editor as full page (UnifiedTaskEditor in edit mode).
 * Same UI as create and as task detail page; embedded with close button.
 */

import { useUIStore } from '@/stores/ui-store';
import { UnifiedTaskEditor } from '@/features/tasks';
import { cn } from '@/lib/utils';
import { toast } from '@/components/ui/toaster';

export function TaskPanel() {
  const { taskPanelOpen, selectedTaskId, closeTaskPanel } = useUIStore();

  if (!taskPanelOpen) return null;
  if (!selectedTaskId) return null;

  const handleBackdropPointerDown = () => {
    if (useUIStore.getState().taskPanelAttachmentUploadBarrier) {
      toast({
        title: 'Upload may not be complete yet. Please wait until the completion message appears.',
        variant: 'destructive',
      });
      return;
    }
    closeTaskPanel();
  };

  return (
    <>
      <div
        data-testid="task-panel-backdrop"
        className="fixed inset-0 z-40 bg-black/60"
        onClick={handleBackdropPointerDown}
        aria-hidden
      />
      <div
        data-testid="task-panel-shell"
        className={cn(
          'fixed right-0 top-0 z-50 flex h-screen w-full max-w-[900px] flex-col',
          'bg-[#1a1a1a] shadow-2xl border-l border-[#333] overflow-hidden'
        )}
      >
        <UnifiedTaskEditor
          mode="edit"
          taskId={selectedTaskId}
          embedded
          onClose={closeTaskPanel}
        />
      </div>
    </>
  );
}
